export class StaticResourcesModel {
  application: String = null;
  vertical: String = null;
  horizontal: String = null;
  documentsPath: String = null;
  parent: String = null;
  desktop: String = null;
  sessionDuration = 0;
  inactiveDuration = 0;
  localStorageDuration = 0;
  nocache = null;
  siteDescription: String = null;
  numeroVerde: String = null;
  email: String = null;
  menu: any;
  footer: any;
  siteNavigationSchema: String = null;
  feedaty: any;
  companies: any[] = null;
}
